const miMessages = {
  "chat.end": "Tīmataria anō tō kōrerorerorero",
  "chat.endall": "Whakamutua te Korero",
  "chat.cancel": "Whakakore",
  "chat.cookie":
    "Ma tenei kaiawhina mamati e whakamahi nga pihikete kia pai ai to wheako",
  "chat.learn": "Ako atu",
  "chat.minimize": "Whakaiti",
  "chat.hide": "Katia",
  "chat.hidebot.text": "Kati ka ngaro te avatar mo te 15 meneti",
  "chat.hidebot": "Katia Bot",
  "chat.restart": "Tīmata anō",
  "switch.language": "Whakawhiti Reo",
  "switch.property": "whakawhiti taonga",
  "restart.converstation": "Tīmataria anō te Whakawhitiwhiti",
  "chat.endtext":
    "Kei te tino hiahia koe ki te whakamutu i te korerorero onāianei?",
  "check.availabity": "Tirohia te waatea",
  "check.availabity.submit": "Tukuna",
  "check.availabity.cancel": "Whakakore",
  "check.availabity.adults": "Nga pakeke ",
  "check.availabity.children": "Tamariki",
  "check.availabity.child.age": "Tau - Tamariki",
  "feedback.leave": "Waiho Urupare",
  "feedback.leave.message": "Waiho Karere",
  "placeholder.name": "Name",
  "placeholder.firstName": "First Name",
  "placeholder.lastName": "Last Name",
  "placeholder.email": " Email",
  "placeholder.phoneNumber": "Phone Number",
  "placeholder.zipcode": "Zip Code",
  "caseform.title": "Tukuna he Take",
  "caseform.system": "Pūnaha",
  "caseform.loading.systems": "Kei te uta pūnaha...",
  "caseform.select.system": "Tīpakohia te Pūnaha",
  "caseform.error.systems": "Hapa i te uta pūnaha",
  "caseform.scenario": "Ahuatanga",
  "caseform.loading.scenarios": "Kei te uta āhuatanga...",
  "caseform.select.scenario": "Tīpakohia te Āhuatanga",
  "caseform.error.scenarios": "Hapa i te uta āhuatanga",
  "caseform.topic": "Kaupapa",
  "caseform.loading.topics": "Kei te uta kaupapa...",
  "caseform.select.topic": "Tīpakohia te Kaupapa",
  "caseform.error.topics": "Hapa i te uta kaupapa",
  "caseform.subject": "Kaupapa",
  "caseform.description": "Whakaahuatanga",
  "caseform.submit": "Tukuna",
  "caseform.cancel": "Whakakore",
  "caseform.success.title": "Take Waihangatia",
  "caseform.success.message": "Kua angitu te waihanga i tō take.",
  "caseform.success.caseNumber": "Tau Take:",
  "caseform.success.ok": "OK",
  "simpleaction.title": "Kōwhiri i tētahi Mahi",
  "simpleaction.body":
    "Tīpakohia tētahi o ngā kōwhiringa e whai ake nei:{br}{b}Waihanga he Take{/b} ki te tuku i tētahi tono tautoko, {b}Tīmata he Korero{/b} ki te hono atu ki tētahi māngai ināianei.",
  "simpleaction.startchat": "Tīmata he Korero",
  "simpleaction.createcase": "Waihanga he Take",
  "caseform.error.generic": "Hapa i te waihanga take.",
  "caseform.error.generic.message":
    "I puta he hapa i te wā i waihangatia ai tō take. Tēnā, whakamātau anō i muri mai.",
};
export default miMessages;
